import styled from '@emotion/styled'

export const CurrentLanguage = styled.span`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-family: Satoshi;
  font-weight: 500;
  font-size: 14px;
  gap: 0.5rem;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
`
